/* ============================================================================
   ALT-MEGAMENU-003 — Left-anchored two-level mega-menu behaviour.
   Drill-down (Level 1 → Level 2) + full modal a11y: focus trap, Escape,
   background `inert`, focus restore to the trigger, `alt-mega-open` page blur.
   Progressive enhancement — without JS the panel stays hidden ([hidden]) and the
   trigger does nothing.
   ========================================================================== */
(function () {
  'use strict';
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function focusables(panel) {
    var all = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < all.length; i++) { if (all[i].getClientRects().length) out.push(all[i]); }
    return out;
  }

  function MegaMenu(trigger) {
    var id = trigger.getAttribute('aria-controls');
    this.trigger = trigger;
    this.panel = id ? document.getElementById(id) : null;
    if (!this.panel) return;
    this.root = this.panel.closest('[data-mega-root]');
    if (!this.root) return;
    this.views = this.panel.querySelectorAll('[data-mega-view]');
    this.inerted = [];
    this._lastCat = null;
    this.bind();
  }

  MegaMenu.prototype.bind = function () {
    var self = this;
    // Move the overlay to <body> so we can inert every other top-level region (modal semantics).
    if (this.root.parentNode !== document.body) document.body.appendChild(this.root);
    this.root.removeAttribute('hidden');
    this.root.setAttribute('data-open', 'false');
    this.setLevel1();

    this.trigger.addEventListener('click', function (e) { e.preventDefault(); self._openedBy = self.trigger; self.open(); });

    // Mobile-first: reuse Dawn's hamburger (shown ≤989px) to open THIS panel
    // instead of the old menu drawer. preventDefault stops the <details> toggle.
    // ALT-CHROME-005: el disparador móvil es ahora nuestro propio <button>
    // ([data-alt-menu-trigger]). Antes era el <summary> del drawer de Dawn, lo que
    // obligaba a interceptar en fase de captura con stopImmediatePropagation para
    // impedir que Dawn abriera su drawer a medias (dejaba el overlay oscuro y el
    // scroll bloqueado al cerrar). Al eliminar el drawer, ese conflicto desaparece
    // y basta un listener normal. Se mantiene un respaldo por si algún tema/plantilla
    // aún renderiza el summary de Dawn.
    this.burger = document.querySelector('[data-alt-menu-trigger]');
    if (this.burger) {
      this.burger.addEventListener('click', function (e) {
        e.preventDefault();
        self._openedBy = self.burger;
        self.open();
      });
    }
    this.burgerDetails = document.getElementById('Details-menu-drawer-container');
    if (this.burgerDetails) {
      document.addEventListener('click', function (e) {
        if (!(e.target.closest && e.target.closest('.header__icon--menu'))) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self._openedBy = self.burger || self.trigger;
        self.open();
      }, true);
    }

    this.root.querySelectorAll('[data-mega-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    this.panel.querySelectorAll('[data-mega-open]').forEach(function (b) {
      b.addEventListener('click', function () { self.openLevel2(b.getAttribute('data-mega-open'), b); });
    });
    this.panel.querySelectorAll('[data-mega-back]').forEach(function (b) {
      b.addEventListener('click', function () { self.back(); });
    });
    this.root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.close(); return; }
      if (e.key === 'Tab') {
        var f = focusables(self.panel);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  };

  MegaMenu.prototype.open = function () {
    if (this.root.getAttribute('data-open') === 'true') return;
    var self = this;
    this.setLevel1();
    if (this.burgerDetails) this.burgerDetails.removeAttribute('open');
    this.inerted = [];
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === self.root || el.hasAttribute('inert')) return;
      el.setAttribute('inert', '');
      self.inerted.push(el);
    });
    document.body.classList.add('alt-mega-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    if (this.burger) this.burger.setAttribute('aria-expanded', 'true');
    void this.root.offsetWidth;
    this.root.setAttribute('data-open', 'true');
    var focusEl = this.panel.querySelector('.mm-close') || this.panel;
    window.setTimeout(function () { try { focusEl.focus(); } catch (e) {} }, mqReduce.matches ? 0 : 80);
  };

  MegaMenu.prototype.close = function () {
    if (this.root.getAttribute('data-open') !== 'true') return;
    var self = this;
    this.root.setAttribute('data-open', 'false');
    document.body.classList.remove('alt-mega-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    if (this.burger) this.burger.setAttribute('aria-expanded', 'false');
    this.inerted.forEach(function (el) { el.removeAttribute('inert'); });
    this.inerted = [];
    try { (this._openedBy || this.trigger).focus(); } catch (e) {}
    window.setTimeout(function () { self.setLevel1(); }, mqReduce.matches ? 0 : 320);
  };

  MegaMenu.prototype.setLevel1 = function () {
    this.panel.setAttribute('data-level', '1');
    this.views.forEach(function (v) { v.setAttribute('hidden', ''); });
    this.panel.querySelectorAll('[data-mega-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  };

  MegaMenu.prototype.openLevel2 = function (handle, btn) {
    var view = this.panel.querySelector('[data-mega-view="' + handle + '"]');
    if (!view) return;
    this.views.forEach(function (v) { v.setAttribute('hidden', ''); });
    view.removeAttribute('hidden');
    this.panel.setAttribute('data-level', '2');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    this._lastCat = btn || null;
    var back = view.querySelector('[data-mega-back]');
    if (back) window.setTimeout(function () { try { back.focus(); } catch (e) {} }, mqReduce.matches ? 0 : 80);
  };

  MegaMenu.prototype.back = function () {
    this.setLevel1();
    if (this._lastCat) { try { this._lastCat.focus(); } catch (e) {} }
  };

  function init() {
    document.querySelectorAll('[data-mega-trigger]').forEach(function (t) {
      if (t.__mega) return;
      t.__mega = new MegaMenu(t);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
